import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import axios from 'axios'
import { AuthHelper } from './helpers/authHelper'
import Notifications from 'vue-notification'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueMoment from 'vue-moment'
import moment from 'moment'
import 'moment/locale/pl'
import { ValidationObserver, ValidationProvider, extend, localize } from 'vee-validate'
import '@/validators/base.validators'
import { VeeValidateMixin } from '@/mixins/veeValidateMixin'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/pl'

// Bootstrap styles
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// VeeValidate
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

// Moment
Vue.use(VueMoment, {
  moment
})

// Bootstrap
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

// Notifications
Vue.use(Notifications)

// Auto auth
const userInfo = AuthHelper.getuserInfo()
if (userInfo) {
  axios.defaults.headers.common.Authorization = `Bearer ${userInfo.token}`
}

// Global mixins
Vue.mixin(VeeValidateMixin)

// Vue configs
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
